import { LoadingManager } from "@core/managers/loading.manager";
import { ETAB_SUBSCRIPTION_STATUS } from "@core/constants";
import { ETAB_ROUTES } from "@etab/config";
import { ACTION_PROFILE_GET_SUBSCRIPTION_STATUS } from "@etab/stores/types";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { useProfileStore } from "@etab/stores/profile";

import SubscriptionFromDemand from "./Subscription-demand.page.vue";
import SubscriptionFromMenu from "./Subscription-menu.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.subscription.menu.path,
      name: ETAB_ROUTES.subscription.menu.name,
      component: SubscriptionFromMenu,
      async beforeEnter(to, from, next) {
        const profileStore = useProfileStore();
        try {
          LoadingManager.show();
          await profileStore[ACTION_PROFILE_GET_SUBSCRIPTION_STATUS]();
          next();
        } catch (error) {
          NotificationsManager.error();
          next({ name: ETAB_ROUTES.userMenu.root.name });
        } finally {
          LoadingManager.hide();
        }
      },
    },
    {
      path: ETAB_ROUTES.subscription.demand.path,
      name: ETAB_ROUTES.subscription.demand.name,
      component: SubscriptionFromDemand,
      async beforeEnter(to, from, next) {
        const profileStore = useProfileStore();
        try {
          LoadingManager.show();
          const subscriptionStatus = await profileStore[ACTION_PROFILE_GET_SUBSCRIPTION_STATUS]();
          const demandId = to.params.demandId;
          if (subscriptionStatus === ETAB_SUBSCRIPTION_STATUS.ACTIVATED) {
            // if we are subscribed we go directly to upfront (no need to see the subscription stuff)
            return next({ name: ETAB_ROUTES.upfront.name, params: { demandId } });
          }
          return next();
        } catch (error) {
          NotificationsManager.error();
          return next({ name: ETAB_ROUTES.creation.root.name });
        } finally {
          LoadingManager.hide();
        }
      },
    },
  ];
}
